import { getRuntimeConfig } from "../config/runtimeConfig";

export const getApiBaseUrl = () => getRuntimeConfig().apiBaseUrl;
